<template>

    <!-- Main content -->
 <div class="content">


 <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">Sucursal</h1>
          </div><!-- /.col -->
          <div class="col-sm-6">

          </div><!-- /.col -->
        </div><!-- /.row -->
      </div><!-- /.container-fluid -->
    </div>

    <div class="container-fluid">

      <div class="row">

<div class="col-12">


            <div class="card ">
              <div class="card-header">

                 <button type="button" @click="abrirModal('lugar','registrar')" class="btn btn-success mb-2"><i class="fas fa-plus-square"></i>&nbsp;Nuevo</button>&nbsp;
                 <div class="form-group row">
                   <div class="col-md-6">
                     <div class="input-group">
                       <select name="" id="" class="form-control col-md-3" v-model="criterio">
                         <!--
                           <option value="nit">Nit</option>
                         <option value="sociedad">Sociedad</option>
                         -->
                         <option value="nombre">Nombre</option>
                         <option value="direccion">Dirección</option>
                       </select>
                       <input type="text" class="form-control" placeholder="Buscar" v-model="buscar" @keyup="listarlugar(1,buscar,criterio)">
                       <button type="submit" class="btn btn-primary" @click="listarlugar(1,buscar,criterio)"><i class="fas fa-search"></i>&nbsp;Buscar</button>
                     </div>
                   </div>
                 </div>

               </div>


              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive">
                <table  class="table table-bordered table-strined table-light">
                  <thead class="thead-dark">
                  <tr>
                    <th>No</th>
                    <th>Opciones</th>
                    <!--
                     <th>Nit</th>
                    <th>Sociedad</th>
                    -->
                    <th>Nombre</th>
                    <th>Direccion</th>
                    <th>Telefono</th>
                    <th>Tipo</th>
                    <th>Estado</th>


                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(lugar,index) in arraylugar" :key="lugar.id" >
                    <td>{{(index + 1)}}</td>
                    <td>
                       <button type="button" @click="abrirModal('lugar','actualizar',lugar)" class="btn btn-warning btn-sm"><i class="fas fa-edit"></i></button>&nbsp;
                      <template v-if="lugar.condicion">
                        <button type="button" class="btn btn-danger btn-sm" @click="desactivarlugar(lugar.id)">
                          <i class="fas fa-trash-alt"></i>
                          </button>
                      </template>
                      <template v-else>
                        <button type="button" class="btn btn-info btn-sm" @click="activarlugar(lugar.id)"><i class="far fa-thumbs-up"></i></button>
                      </template>

                    </td>
                    <!--
                                    <td v-text="lugar.nit"></td>
                                    <td v-text="lugar.sociedad"></td>
                                    -->
                                    <td v-text="lugar.nombre"></td>
                                    <td v-text="lugar.direccion"></td>
                                    <td v-text="lugar.telefono"></td>
                                    <td>
                                      <div v-if="lugar.tipo==1">
                                      <span class="badge badge-info"> Tienda </span>
                                      </div>
                                      <div v-else>
                                      <span class="badge badge-warning"> Bodega </span>
                                      </div>
                                    </td>


                   <td>
                       <div v-if="lugar.condicion">
                            <span class="badge badge-success"> Activo </span>
                       </div>
                       <div v-else>
                            <span class="badge badge-danger"> Desactivado </span>
                       </div>

                   </td>

                  </tr>


                  </tbody>
                  <tfoot>

                  </tfoot>
                </table>
                <div class="card-footer clearfix">
                 <nav>
                <ul class="pagination pagination-sm m-0 float-right">
                  <li class="page-item" v-if="pagination.current_page > 1">
                    <a class="page-link" href="#" @click="cambiarPagina(pagination.current_page - 1,buscar,criterio)" >&laquo;</a>
                 </li>
                  <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                    <a class="page-link" href="#" @click="cambiarPagina(page,buscar,criterio)" v-text="page"></a>
                    </li>
                  <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                    <a class="page-link" href="#" @click="cambiarPagina(pagination.current_page + 1,buscar,criterio)">&raquo;</a>
                    </li>
                </ul>
                </nav>
              </div>
            </div>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>






<div tabindex="-1" class="modal fade p-5" :class="{'mostrar' : modal}" >
        <div class="modal-dialog modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header bg-primary">
              <h4 class="modal-title" v-text="tituloModal"></h4>
              <button type="button" class="close" @click="cerrarModal()" >
                <span aria-hidden="true" class="text-white">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                 <div class="container-fluid">
                    <form action="" method="post" enctype="multipart/form-data" class="form-horizontal">

                    <div class="form-group row">
                      <label class="col-md-3 form-control-label" >Tipo </label>
                         <select class="form-control" v-model="tipo">
                            <option value="0" disabled>Seleccione</option>
                            <option value="1">Tienda</option>
                            <option value="2">Bodega</option>
                        </select>
                    </div>
<!--
                   <div class="form-group row">
                      <label for="recipient-name" class="col-form-label">nit:</label>
                      <input type="text" class="form-control" @blur="duplicado()"  v-model="nit">
                    </div>

                     <div class="form-group row">
                      <label for="recipient-name" class="col-form-label">sociedad:</label>
                      <input type="text" class="form-control" v-model="sociedad">
                    </div>
-->
                  <div class="form-group row">
                      <label for="recipient-name" class="col-form-label">Nombre:</label>
                      <input type="text" class="form-control"  @blur="duplicado()"  v-model="nombre">
                    </div>

                    <div class="form-group row">
                      <label for="message-text" class="col-form-label">Direccion:</label>
                        <input type="text" class="form-control"  v-model="direccion" >
                    </div>

                    <div class="form-group row">
                      <label for="message-text" class="col-form-label">Telefono:</label>
                        <input type="text" class="form-control"  v-model="telefono" >
                    </div>


                    <div v-show="errorlugar" class="form-growp row  div-error">
                        <div class="text-center text-error">
                                          <div v-for="error in errorMostrarMsjlugar" :key="error" v-text="error">
                                          </div>
                                      </div>
                    </div>
                    <div v-show="deshabilitar_boton" class="form-growp row  div-error">
                      <p class="text-center text-error">La lugar ya Existe!</p>
                    </div>
                    </form>
                 </div>
            </div>
            <div class="modal-footer ">
              <button type="button" class="btn btn-default"  @click="cerrarModal()">Close</button>
              <button type="button" v-if="tipoAccion==1" :disabled = "deshabilitar_boton==1"  class="btn btn-primary" @click="registrarlugar()">Guardar</button>
               <button type="button" v-if="tipoAccion==2" class="btn btn-primary" @click="actualizarlugar()">Actualizar</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->




      <!-- /.row -->
    </div><!-- /.container-fluid -->

  <!-- /.content -->
</template>
<script>




export default {

       data (){
            return {
                lugar_id: 0,
                tipo : '',
                nit : '',
                sociedad : '',
                nombre : '',
                direccion : '',
                telefono : '',
                arraylugar : [],
                modal : 0,
                tituloModal : '',
                tipoAccion : 0,
                errorlugar : 0,
                errorMostrarMsjlugar : [],
                 'mensaje':'',
                 deshabilitar_boton:0,
                'val1':0,
                    'val2':0,
                    'val3':0,
                    'val4':0,
                pagination : {
                    'total' : 0,
                    'current_page' : 0,
                    'per_page' : 0,
                    'last_page' : 0,
                    'from' : 0,
                    'to' : 0,

                },
                offset : 3,
                criterio : 'nombre',
                buscar : ''
            }
        },




        computed:{



            isActived: function(){
                return this.pagination.current_page;
            },
            //Calcula los elementos de la paginación
            pagesNumber: function() {
                if(!this.pagination.to) {
                    return [];
                }

                var from = this.pagination.current_page - this.offset;
                if(from < 1) {
                    from = 1;
                }

                var to = from + (this.offset * 2);
                if(to >= this.pagination.last_page){
                    to = this.pagination.last_page;
                }

                var pagesArray = [];
                while(from <= to) {
                    pagesArray.push(from);
                    from++;
                }
                return pagesArray;

            }
        },
        methods : {
            listarlugar (page,buscar,criterio){

                let me=this;
                 var url= '/lugar?page=' + page + '&buscar='+ buscar + '&criterio='+ criterio;
                axios.get(url).then(function (response) {
                    var respuesta= response.data;
                    me.arraylugar = respuesta.lugar.data;
                    me.pagination= respuesta.pagination;
                })
                .catch(function (error) {
                    console.log(error);
                });
            },



            cambiarPagina(page,buscar,criterio){
                let me = this;
                //Actualiza la página actual
                me.pagination.current_page = page;
                //Envia la petición para visualizar la data de esa página
                me.listarlugar(page,buscar,criterio);
            },



            registrarlugar(){
                if (this.validarlugar()){
                    return;
                }

                let me = this;

                axios.post('/lugar/registrar',{

                    'tipo': this.tipo,
                    /*
                    'nit': this.nit,
                    'sociedad': this.sociedad,
                    */
                    'nombre': this.nombre,
                    'direccion': this.direccion,
                     'telefono': this.telefono


                }).then(function (response) {

                    me.cerrarModal();
                    me.deshabilitar_boton=0;
                    me.listarlugar(1,'','nombre');
                     Swal.fire({
                          position: 'top',
                          icon: 'success',
                          title: 'Datos Agregados Con Exito!',
                          showConfirmButton: false,
                          timer: 1500
                        });
                }).catch(function (error) {
                    console.log(error);
                });
            },


            actualizarlugar(){

               if (this.validarlugar()){
                    return;
                }

                let me = this;


                axios.put('/lugar/actualizar',{

                    /*
                    'nit': this.nit,
                    'sociedad': this.sociedad,
                    */
                    'nombre': this.nombre,
                    'direccion': this.direccion,
                    'telefono': this.telefono,
                    'tipo': this.tipo,

                    'id': this.lugar_id


                }).then(function (response) {
                    me.cerrarModal();
                    me.listarlugar(1,'','nombre');
                        Swal.fire({
                          position: 'top',
                          icon: 'success',
                          title: 'Datos Agregados Con Exito!',
                          showConfirmButton: false,
                          timer: 1500
                        });

                }).catch(function (error) {
                    console.log(error);
                });

            },


           duplicado(){
             //console.log(this.nombre);
               axios.put('/lugar/validar',{



                    'nombre': this.nombre

                }).then(response => {
                  this.mensaje = response.data;
                  //console.log(this.mensaje);
                  if(this.mensaje==="Existe"){
                      this.deshabilitar_boton=1;

                  }else{
                    this.deshabilitar_boton=0;
                  }
                })
                .catch(error => {
                   console.log(err);
                 });

            },



             validarlugar(){


               this.errorlugar=0;
                this.errorMostrarMsjlugar  =[];


                 if (this.tipo==0){
                   this.errorMostrarMsjlugar.push("El Tipo no puede estar vacio.");

                }
                /*
                 if (!this.nit){
                   this.errorMostrarMsjlugar.push("El nit no puede estar vacio.");

                }

                 if (!this.sociedad){
                   this.errorMostrarMsjlugar.push("La sociedad no puede estar vacia.");

                }
               */
                if (!this.nombre){
                   this.errorMostrarMsjlugar.push("El nombre no puede estar vacio.");

                }

                 if (!this.direccion){
                   this.errorMostrarMsjlugar.push("La Dirección no puede estar vacia.");

                }

                 if (!this.telefono){
                   this.errorMostrarMsjlugar.push("El Telefono no puede estar vacia.");

                }




                if (this.errorMostrarMsjlugar.length) this.errorlugar = 1;

                return this.errorlugar;

            },
            cerrarModal(){
                this.modal=0;
                this.tituloModal='';
                this.tipo='';
                /*
                this.nit='';
                this.sociedad='';
                */
                this.nombre='';
                this.direccion='';
                this.telefono='';
                this.errorlugar=0;
                this.val1=0;
                this.val2=0;

            },
            abrirModal(modelo, accion, data = []){



                switch(modelo){
                    case "lugar":
                    {
                        switch(accion){
                            case 'registrar':
                            {
                               this.modal = 1;
                                this.tituloModal = 'Registrar lugar';
                                this.tipo=0;
                                /*
                                this.nit='';
                                this.sociedad='';
                                */
                                this.nombre='';
                                this.direccion='';
                                this.telefono='';
                                this.tipoAccion = 1;
                                break;
                            }
                            case 'actualizar':
                            {
                                //console.log(data);
                                this.modal=1;
                                this.tipoAccion=2;
                                this.tituloModal='Actualizar lugar';
                                this.lugar_id=data['id'];
                                /*
                                this.sociedad= data['sociedad'];
                                this.nit = data['nit'];
                                */
                                this.tipo = data['tipo'];
                                this.nombre = data['nombre'];
                                this.direccion = data['direccion'];
                                this.telefono = data['telefono'];


                                break;
                            }
                        }
                    }
                }

            },

           desactivarlugar : function(id){
              Swal.fire({
                title: 'Esta seguro/a que desea desactivar el lugar?',

                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar'
              }).then((result) => {
                if (result.value) {
                  let me = this;
                        axios.put('/lugar/desactivar',{
                          'id': id
                        }).then(function(response){
                          me.listarlugar(1,'','nombre');
                          Swal.fire(
                            'Desactivado!',
                            'El registro a sido desactivado con exito.',
                            'success'
                          )
                        }).catch(function(error){
                          console.log(error);
                        });


                // For more information about handling dismissals please visit
                // https://sweetalert2.github.io/#handling-dismissals
                } else if (result.dismiss === Swal.DismissReason.cancel) {

                }
              })
                },


               activarlugar: function(id){

                Swal.fire({
                title: 'Esta seguro/a que desea activar lugar?',

                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar'
              }).then((result) => {
                if (result.value) {
                  let me = this;
                        axios.put('/lugar/activar',{
                          'id': id
                        }).then(function(response){
                         me.listarlugar(1,'','nombre');
                          Swal.fire(
                            'activado!',
                            'El registro a sido activado con exito.',
                            'success'
                          )
                        }).catch(function(error){
                          console.log(error);
                        });


                // For more information about handling dismissals please visit
                // https://sweetalert2.github.io/#handling-dismissals
                } else if (result.dismiss === Swal.DismissReason.cancel) {

                }
              })


              }


        },
        mounted() {
            this.listarlugar(1,this.buscar,this.criterio);
        }
    }
</script>
<style>
.modal-content{
    width: 100% !important;
    position: absolute !important;
}

.mostrar{
    display: list-item !important;
    opacity: 1 !important;
    position: absolute !important;
    background-color: #3c29297a !important;

}

.diverror{
  display: flex;
  justify-content: center;
}

.text-error{
  color: red;
  font-weight: bold;
}

</style>
